var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25232",
    "data-name": "Group 25232",
    transform: "translate(-1766 -163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25229",
    "data-name": "Group 25229",
    transform: "translate(1766 163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24900",
    "data-name": "Group 24900",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#396"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "direct-download",
    transform: "translate(1773 169.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M8.463,2a.307.307,0,0,0-.222.1L6.085,4.353a.308.308,0,0,0,.222.521H7.436V7.234a.514.514,0,0,0,.513.513H8.976a.514.514,0,0,0,.513-.513V4.874h1.129a.308.308,0,0,0,.222-.521L8.685,2.1A.307.307,0,0,0,8.463,2Z",
    transform: "translate(-3.537 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M9.134,19.642H.718A.719.719,0,0,1,0,18.924v-.205A.719.719,0,0,1,.718,18H9.134a.719.719,0,0,1,.718.718v.205A.719.719,0,0,1,9.134,19.642Z",
    transform: "translate(0 -11.432)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowCircle);
export default __webpack_public_path__ + "static/media/upload-arrow_circle.7d93637c12eff8d23add044933ec3115.svg";
export { ForwardRef as ReactComponent };